import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';

import './styles/main.scss';
import App from './App';

ReactDOM.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
  document.getElementById('root')
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Воркер успешно зарегистрирован! Scope:', registration.scope);
      })
      .catch((err) => {
        console.log('Ошибка регистрации воркера: ', err);
      });
  });
}